import { clsx } from 'clsx'

export const cn = (...classValues: unknown[]) => {
  return clsx(classValues)
}
